/**
 * Component - testimonialsList
 */

export const testimonialsList = ():void => {
  // Run the script for each individual component found on the page
  const componentSelector = document.querySelectorAll('.js-testimonialsList') as unknown as HTMLElement[]
  componentSelector.forEach((component:HTMLElement) => {
    const singleList: HTMLElement[] = Array.from(component.querySelectorAll('.js-testimonialsList-activeSingle'))
    const miniaturesList: HTMLElement[] = Array.from(component.querySelectorAll('.js-testimonialsList-othersSingle'))
    const triggerList: HTMLElement[] = Array.from(component.querySelectorAll('.js-testimonialsList-othersSingle-trigger'))

    triggerList.forEach((trigger:HTMLElement) => {
      trigger.addEventListener('click', () => {
        miniaturesList.forEach((elem) => {
          elem.classList.remove('-active')
        })

        const triggerID = parseInt(trigger.dataset.testimonialslistkey as string)
        const triggerParent = trigger.closest('.js-testimonialsList-othersSingle')

        if (triggerParent) { triggerParent.classList.add('-active') }

        singleList.forEach((elem) => {
          elem.classList.remove('-active')
        })
        const currentActive = component.querySelector(`.js-testimonialsList-activeSingle[data-testimonialslistkey="${triggerID}"]`)
        if (currentActive) {
          currentActive.classList.add('-active')

          // Scroll to the top
          let headerHeight = (jQuery('header')) ? jQuery('header').height() : 0
          let specialScroll = jQuery(component)
          if (specialScroll.length > 0) {
            jQuery('html, body').animate({
              scrollTop: specialScroll.offset().top - headerHeight
            }, 800)

            setTimeout(() => {
              jQuery('html, body').animate({
                scrollTop: specialScroll.offset().top - headerHeight
              }, 0)
            }, 800)
          }
        }
      })
    })
  })
}
